/**
 * @property VOICES
 * @type {Array}
 * @final
 */
export const VOICES = [
    'Alex',
    'Daniel',
    'Fiona',
    'Google US English',
    'Google UK English Female',
    'Google UK English Male'
];

/**
 * @property LOWER_PITCH
 * @type {float}
 * @final
 */
export const LOWER_PITCH = 0.9;

/**
 * @property HIGHER_PITCH
 * @type {float}
 * @final
 */
export const HIGHER_PITCH = 1.125;

/**
 * @property NORMAL_SPEED
 * @type {float}
 * @final
 */
export const NORMAL_SPEED = 1.0;

/**
 * @property FASTER_SPEED
 * @type {float}
 * @final
 */
export const FASTER_SPEED = 1.125;
